import VisibilityIcon from '@material-ui/icons/Visibility';
import React from 'react';
import { Col, Row } from 'react-grid-system';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import { connect } from "react-redux";
import { saveFormulariosData, saveServiciosFilterData } from "../../../common/Actions";
import Btn from "../../../common/components/Btn/Btn";
import Select from "../../../common/components/Fields/Select";
import Text from "../../../common/components/Fields/Text";
import Provider from "../../../common/components/Provider/Provider";
import Helpers from "../../../common/Helpers";
import { resource } from "../../../common/lang/lang";
import Store from "../../../common/Store";
import ClientsServcices from "../../../services/Clients";
import ConductoresService from "../../../services/Conductores";
import VehiclesService from "../../../services/Vehicles";
import ServiciosServices from '../../../services/Servicios';
import EditIcon from '@material-ui/icons/Edit';
import TablePagination from '@material-ui/core/TablePagination';
import Date from "../../../common/components/Fields/Date";
import { Cancel, CheckCircle, DescriptionRounded, FiberManualRecordRounded } from '@material-ui/icons';
import { Modal, TextField } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

class Lista extends React.Component {

    Cities = resource('Cities');
    Vehicles = resource('VehicleType');
    _mounted = false;
    _searchTimeout = null;

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            page: 0,
            total: 0,
            rowsPerPage: 10,
            type: props.type,
            isOpenNewCancelation: false,
            clients: [],
            vehicles: [],
            conductores: [],
            rowAssignments: {}
        };
    }

    isAdmin = () => Number(this.props.user?.role) === 1;

    componentDidMount() {
        this._mounted = true;
        this.getAll();
    }

    componentWillUnmount() {
        this._mounted = false;
        if (this._searchTimeout) clearTimeout(this._searchTimeout);
    }

    async getAll() {
        let [clients, vehicles, conductores] = await Promise.all([
            ClientsServcices.get(-1),
            VehiclesService.get(-1),
            ConductoresService.get(-1)
        ]);
        this.setState(() => ({
            clients: clients.data || [],
            vehicles: vehicles.data || [],
            conductores: conductores.data || []
        }));
        await this.getData();
    }

    async getData() {
        Helpers.loader();
        let form = Store.getState().serviciosFilter;
        let type = localStorage.getItem('type');
        let typeTable = (type) ? type : this.state.type;
        let cotizacion = await ServiciosServices.getState(0, typeTable, form, this.state.rowsPerPage);
        if (!this._mounted) return;
        this.setState(() => ({ data: cotizacion.data, total: cotizacion.total, page: 0 }));
        Helpers.closeLoader();
    }

    edit = id => () => this.props.history.push(`/servicio/edit/${id}`);
    view = id => () => this.props.history.push(`/servicio/view/${id}`);
    showTwnel = id => () => this.props.history.push(`/serviciotwnel/${id}`);

    cancelarServicio = (idService) => {
        this.setState(() => ({ isOpenNewCancelation: true, idService: idService }))
    }

    asignar = async (idService) => {

        const res = await Helpers.confirm({ title: 'Asignación', text: '¿Asignar servicio?' })

        if (res) {
            const response = await ServiciosServices.assignService(idService);
            if (response.status) {
                Helpers.alert({ title: 'Asignación', text: response.message });
                this.getData();
            }
        }

    }

    onRowAssignmentChange = (serviceId, field, value) => {
        this.setState((prev) => ({
            rowAssignments: {
                ...prev.rowAssignments,
                [serviceId]: {
                    ...prev.rowAssignments[serviceId],
                    [field]: value
                }
            }
        }));
    };

    preAsignarFila = async (item) => {
        const assignment = this.state.rowAssignments[item.id] || {};
        if (!assignment.vehiculo || !assignment.conductor_id) {
            Helpers.alert({ title: 'Asignación', text: 'Debe seleccionar conductor y vehículo' });
            return;
        }

        try {
            const res = await Helpers.confirm({
                title: 'Asignación',
                text: '¿Asignar conductor y vehículo a este servicio?'
            });
            if (!res) return;

            Helpers.loader();
            const response = await ServiciosServices.preAssignFromList({
                id: item.id,
                vehiculo: assignment.vehiculo,
                conductor_id: assignment.conductor_id
            });
            Helpers.closeLoader();

            if (response.status) {
                Helpers.alert({ title: 'Asignación', text: response.message });
                this.setState((prev) => {
                    const rowAssignments = { ...prev.rowAssignments };
                    delete rowAssignments[item.id];
                    return { rowAssignments };
                });
                this.getData();
            } else {
                Helpers.alert({ title: 'Error', text: response.message || 'No se pudo pre-asignar el servicio' });
            }
        } catch (e) {
            Helpers.closeLoader();
        }
    };

    asignarTodos = async () => {

        const res = await Helpers.confirm({ title: 'Asignación', text: '¿Desea asignar todos los servicios pre-asignados?' });

        let form = Store.getState().serviciosFilter;
        if (form.fecha_ida) {
            form = { fecha_ida: form.fecha_ida };
        } else {
            form = {};
        }

        if (res) {
            Helpers.loader();
            const response = await ServiciosServices.assignAllPreAsigned(form);
            Helpers.closeLoader();
            if (response.status) {
                Helpers.alert({ title: 'Asignación', text: response.message });
                this.getData();
            }
        }
    }

    changePage = async (event, page) => {
        Helpers.loader();
        let form = Store.getState().serviciosFilter;
        let cotizacion = await ServiciosServices.getState(page, this.state.type, form, this.state.rowsPerPage);
        this.setState(() => ({ data: cotizacion.data, total: cotizacion.total, page }));
        Helpers.closeLoader();
    };

    changeRowsPerPage = async (event) => {
        const rowsPerPage = parseInt(event.target.value, 10);
        Helpers.loader();
        let form = Store.getState().serviciosFilter;
        let type = localStorage.getItem('type');
        let typeTable = (type) ? type : this.state.type;
        let cotizacion = await ServiciosServices.getState(0, typeTable, form, rowsPerPage);
        this.setState(() => ({ data: cotizacion.data, total: cotizacion.total, page: 0, rowsPerPage }));
        Helpers.closeLoader();
    };

    search = () => {
        this.setState(() => ({ page: 0 }));
        this.getData();
    };

    onFilterChange = () => {
        this.search();
    };

    onConsecutivoChange = () => {
        if (this._searchTimeout) clearTimeout(this._searchTimeout);
        this._searchTimeout = setTimeout(() => {
            this.search();
        }, 500);
    };

    saveCancelation = async () => {
        const form = Store.getState().formularios;
        const idService = this.state.idService;

        const response = await Helpers.confirm({
            text: '¿Seguro desea cancelar servicio?',
            title: 'Cancelación',
        })

        if (response) {
            const { status, message } = await ServiciosServices.cancelService({ id: idService, message: form.message });

            if (status) {
                Helpers.alert({ text: message });
                this.setState(() => ({ isOpenNewCancelation: false, idService: null }));
                this.getData();
            }
        }
    }

    closeModal = () => {
        this.setState(() => ({ isOpenNewCancelation: false, idService: null }));
    }

    render() {
        const { state, props: { fecha_ida, type } } = this;
        const isAdmin = this.isAdmin();
        return (
            <div className="wrap table">
                <Provider store={'serviciosFilter'} save={saveServiciosFilterData}>
                    <Row className="row">
                        <Col md={3}>
                            <Text name="consecutivo" label="Nº Serv." change={this.onConsecutivoChange} className={"w-100"} />
                        </Col>
                        <Col md={3}>
                            <Date name="fecha_ida" label="Fecha ida" change={this.onFilterChange} className={"w-100"} />
                        </Col>
                        <Col md={3}>
                            <Select name="client" label="Cliente" optionLabel={Helpers.clientsLabels} opts={state.clients} hash="id" clear change={this.onFilterChange} className={"w-100"} />
                        </Col>
                        <Col md={3}>
                            <Select name="origen" label="Origen" opts={this.Cities} clear change={this.onFilterChange} className={"w-100"} />
                        </Col>
                    </Row>
                    <Row className="row">
                        <Col md={3}>
                            <Select name="destino" label="Destino" opts={this.Cities} clear change={this.onFilterChange} className={"w-100"} />
                        </Col>
                        <Col md={3}>
                            <Select name="vehicle_type" label="Tipo vehículo" opts={this.Vehicles} clear change={this.onFilterChange} className={"w-100"} />
                        </Col>
                        <Col md={3}>
                            <Select name="placa" label="Placa" optionLabel={Helpers.vehicleLabels} opts={state.vehicles} hash="id" clear change={this.onFilterChange} className={"w-100"} />
                        </Col>
                        <Col md={3}>
                            <Select name="conductor" label="Conductor" optionLabel={Helpers.driveLabels} opts={state.conductores} hash="id" clear change={this.onFilterChange} className={"w-100"} />
                        </Col>
                    </Row>
                </Provider>
                <TableContainer>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Nº Serv.</TableCell>
                                <TableCell>F. Ida</TableCell>
                                <TableCell>Cliente.</TableCell>
                                <TableCell>Origen</TableCell>
                                <TableCell>Destino</TableCell>
                                <TableCell>T. Vehículo.</TableCell>
                                <TableCell>H. Inicio.</TableCell>
                                <TableCell>Placa</TableCell>
                                <TableCell>Cond.</TableCell>
                                {type !== 0 && <TableCell>N. Cond.</TableCell>}
                                <TableCell>Valor</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {Array.isArray(state.data) && state.data.map((item, key) => {
                                const canAssign = isAdmin && Number(item.state) === 0;
                                const assignment = state.rowAssignments[item.id] || {};
                                return (
                                <React.Fragment key={key}>
                                    <TableRow>
                                        <TableCell>{item.consecutivo}</TableCell>
                                        <TableCell style={{ width: 105 }}>{item.fecha_ida}</TableCell>
                                        <TableCell style={{ width: 240 }}>{item.cliente.names}</TableCell>
                                        <TableCell>{Helpers.getStatic(item.origen, this.Cities).name}</TableCell>
                                        <TableCell>{Helpers.getStatic(item.destino, this.Cities).name}</TableCell>
                                        <TableCell>{Helpers.getStatic(item.vehicle_type, this.Vehicles).name}</TableCell>
                                        <TableCell>{item.hour}</TableCell>
                                        <TableCell style={{ minWidth: canAssign ? 160 : undefined }}>
                                            {canAssign ? (
                                                <Autocomplete
                                                    size="small"
                                                    options={state.vehicles}
                                                    getOptionLabel={(option) => Helpers.vehicleLabels(option) || ''}
                                                    getOptionSelected={(option, value) => option.id == value.id}
                                                    value={state.vehicles.find((v) => v.id == assignment.vehiculo) || null}
                                                    onChange={(e, option) => this.onRowAssignmentChange(item.id, 'vehiculo', option ? option.id : '')}
                                                    style={{ minWidth: 140 }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} placeholder="Placa" margin="dense" style={{ paddingLeft: '5px' }} />
                                                    )}
                                                />
                                            ) : item.vehiculo?.plate}
                                        </TableCell>
                                        <TableCell style={{ minWidth: canAssign ? 180 : undefined }}>
                                            {canAssign ? (
                                                <Autocomplete
                                                    size="small"
                                                    options={state.conductores}
                                                    getOptionLabel={(option) => Helpers.driveLabels(option) || ''}
                                                    getOptionSelected={(option, value) => option.id == value.id}
                                                    value={state.conductores.find((c) => c.id == assignment.conductor_id) || null}
                                                    onChange={(e, option) => this.onRowAssignmentChange(item.id, 'conductor_id', option ? option.id : '')}
                                                    style={{ minWidth: 160 }}
                                                    renderInput={(params) => (
                                                        <TextField {...params} placeholder="Conductor" margin="dense" style={{ paddingLeft: '5px' }} />
                                                    )}
                                                />
                                            ) : ((item.conductores.length) && item.conductores[0].conductores?.name)}
                                        </TableCell>
                                        {type !== 0 && <TableCell>
                                            Int.:{item.conductores.filter(e => e.conductores?.type === 1).length}
                                            <br />
                                            Ext.:{item.conductores.filter(e => e.conductores?.type === 2).length}
                                        </TableCell>}
                                        <TableCell>{item.total}</TableCell>
                                        <TableCell className="last-td" style={{ minWidth: 120 }}>
                                            {item.state !== 5 && <IconButton size="small" onClick={this.edit(item.id)}><EditIcon /></IconButton>}
                                            {item.state === 5 && <IconButton size="small" onClick={this.view(item.id)}><VisibilityIcon /></IconButton>}
                                            {item.state >= 2 && <IconButton size="small" onClick={this.showTwnel(item.id)}><VisibilityIcon /></IconButton>}
                                            {(item.state < 2 || item.state == 8) && <IconButton size="small" onClick={() => this.cancelarServicio(item.id)}> <Cancel /> </IconButton>}

                                            {canAssign && <IconButton about='Asignar conductor y vehículo' title='Asignar conductor y vehículo' size="small" onClick={() => this.preAsignarFila(item)}> <CheckCircle /> </IconButton>}

                                            {/* Solo servicios tipo 8 que son pre-asignados */}
                                            {item.state == 8 && <IconButton about='Asignar' title='Asignar' size="small" onClick={() => this.asignar(item.id)}> <CheckCircle /> </IconButton>}

                                            {(item.state === 3 && item.factura !== null && item.factura !== "") && <IconButton about='Factura' title='Tiene factura' size="small" onClick={() => this.view(item.id)}> <DescriptionRounded /> </IconButton>}
                                            {(item.factura_relacionada === 1) && <IconButton title='Factura relacionada' size='small'>
                                                <FiberManualRecordRounded color="primary" title="Factura relacionada" />
                                            </IconButton>}
                                        </TableCell>
                                    </TableRow>
                                </React.Fragment>
                            )})}
                        </TableBody>


                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={state.total}
                        rowsPerPage={state.rowsPerPage}
                        page={state.page}
                        onChangePage={this.changePage}
                        onChangeRowsPerPage={this.changeRowsPerPage}
                    />
                </TableContainer>

                {
                    (type == 8 && state.data.length > 0) &&
                    <div className='btns'>
                        <Btn type={"primary"} text={fecha_ida ? "Aprovar por fechas" : "Aprobar todos"} click={() => this.asignarTodos()} />
                    </div>
                }
                <Modal open={state.isOpenNewCancelation}>
                    <div className="modal formdata">
                        <div className="header">
                            <h4>Cancelación de servicio</h4>
                        </div>
                        <div className="body wrap">
                            <Provider save={saveFormulariosData} store="formularios">
                                <div>
                                    <Text label={"Razón de cancelación"} name={"message"} />
                                </div>
                            </Provider>
                            <div className='btns'>
                                <Btn text={"Cancelar servicio"} click={() => this.saveCancelation()} type={"primary"} />
                            </div>
                            <Btn click={() => this.closeModal()} text="Cancelar" type="secondary" class="remove" />
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default connect(
    (store) => ({
        fecha_ida: store.formularios.fecha_ida,
        user: store.user
    }),
    (dispatch) => ({}),
)(Lista);
